import { render } from "./GridDrepturiUtilizatori.vue?vue&type=template&id=192cacab&scoped=true&ts=true"
import script from "./GridDrepturiUtilizatori.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiUtilizatori.vue?vue&type=script&lang=ts"

import "./GridDrepturiUtilizatori.vue?vue&type=style&index=0&id=192cacab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192cacab"]])

export default __exports__